import React from 'react'
import "./Testimonial.css"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Zoom from 'react-reveal/Zoom';

function Testimonial() {


    const data = [
        {
            name: "Ali",
            posstion: "CEO",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"
        },

        {
            name: "Gedi",
            posstion: "CTO",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
        },


        {
            name: "Ahmed",
            posstion: "Marketing Manager",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1557862921-37829c790f19?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80"
        },


        {
            name: "Guure",
            posstion: "Partener",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80"
        },

        {
            name: "Isaak",
            posstion: "Director",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
        },


        {
            name: "Jey Patter",
            posstion: "Senior Developer",
            des: "when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has ....",
            image: "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=580&q=80"
        }
    ]

    const colors = [
        "#FFA233",
        "#336BFF",
        "#6133FF",
        "#C433FF",
        "#FF33DD",
        "#FF337D",
        "#FFF333",
        "#33FFAC",
        "#33DAFF",
        "#8A33FF",
        "#8DFF33",
        "#33FFDD",
      ];
    

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 4,
        initialSlide: 0,
        autoplay: true,
        rows: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };


    return (
        <div id='testimonial' className='container Testimonial-section'>
            <div className="section-titel">
                <h5>Testmonial</h5>
                <span className='line1'></span>
            </div>


            <div className="con">

                <div className="testimonial-slider" >
                    <Slider {...settings}>


                        {data.map((item, index) => (
                            <Zoom> <div className='content-slider-main'>
                                <div className="content-slider" key={index} style={{backgroundColor: colors[index]}}>
                                    <img src={item.image} alt="testimonial image" className='center-image' />
                                    <p>{item.name}</p>
                                    <p>{item.posstion}</p>
                                    <p>{item.des}</p>
                                </div>
                            </div></Zoom>


                        ))}
                    </Slider>
                </div>
            </div>


        </div>
    )
}

export default Testimonial